import React from 'react';
import PropTypes from 'prop-types';

import {
  Text,
} from './styles';

const VideosApprovedCount = (props) => {
  const {
    testSessions,
    isUnmoderated,
  } = props;

  const approvedCount = testSessions.filter((session) => {
    if (isUnmoderated) {
      return session.approved;
    }
    return session.approved && session.tester.approved;
  }).length;

  return (
    <Text>
      Videos Approved:
      {' '}
      {approvedCount || 0}
    </Text>
  );
};

VideosApprovedCount.defaultProps = {
  testSessions: [],
};

VideosApprovedCount.propTypes = {
  testSessions: PropTypes.arrayOf(PropTypes.shape()),
  isUnmoderated: PropTypes.bool.isRequired,
};
export default VideosApprovedCount;
